import { withInstall } from '../../utils'

import _Calendar from './src/calendar.vue'

export const SdCalendar = withInstall(_Calendar)
export default SdCalendar

export * from './src/calendar'
